@use '@fpsm/cxy-scss' as cxy;

.authenticationContainer {
  display: flex;
  flex-direction: column;
  background: linear-gradient(223deg, #335d73 10%, #012241 60%);
  color: var(--cxy-color-content-on-inverse);
  border-radius: var(--cxy-border-radius-m);
  overflow: hidden;
}
@media (min-width: 768px) {
  .authenticationContainer {
    flex-direction: row;
  }
}

/* WhoScored theme override */
[data-fpsm-theme='whoscored'] .authenticationContainer {
  background: linear-gradient(223deg, #2a2a2a 10%, #0f0f0f 60%);
}

/* WhoScored theme - black checkmarks for square icons */
[data-fpsm-theme='whoscored'] .featureList li svg path {
  fill: var(--cxy-color-icon-black);
}

.infoLink {
  margin-top: var(--cxy-spacing-3);
  font-size: var(--cxy-fontSize-xs);
  line-height: var(--cxy-lineHeight-s);
}
@media (min-width: 768px) {
  .infoLink {
    margin-top: var(--cxy-spacing-7);
    font-size: var(--cxy-fontSize-m);
    line-height: var(--cxy-lineHeight-l);
  }
}
.infoLink a {
  color: var(--cxy-color-brand);
}

.featureList {
  display: none;
}
@media (min-width: 768px) {
  .featureList {
    @include cxy.stack(var(--cxy-spacing-2));
    margin-top: var(--cxy-spacing-8);
  }
}
.featureList li {
  display: flex;
  align-items: center;
}
.featureList li svg {
  width: 1rem;
  height: 1rem;
  color: var(--cxy-color-brand);
}
@media (min-width: 768px) {
  .featureList li svg {
    width: 1.5rem;
    height: 1.5rem;
  }
}
.featureList li span {
  margin-left: var(--cxy-spacing-2);
  font-weight: var(--cxy-fontWeight-bold);
  font-size: var(--cxy-fontSize-s);
  line-height: var(--cxy-lineHeight-xs);
}

.logoContainer {
  display: flex;
  align-items: center;
}

.header {
  font-size: var(--cxy-fontSize-m);
  line-height: var(--cxy-lineHeight-xs);
  font-family: 'futura-pt-condensed', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
  color: var(--cxy-color-brand);
  margin-top: var(--cxy-spacing-4);
}
@media (min-width: 768px) {
  .header {
    font-size: 2rem;
    line-height: 2.25rem;
    margin-top: var(--cxy-spacing-6);
  }
}

.infoSection {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: var(--cxy-spacing-4);
}
@media (min-width: 768px) {
  .infoSection {
    padding: var(--cxy-spacing-8);
    width: 334px;
    flex-shrink: 0;
    background-color: var(--cxy-color-container-dark);
  }
}
.infoSection img {
  width: 100%;
  max-width: 200px;
}
@media (min-width: 768px) {
  .infoSection img {
    max-width: 250px;
  }
}
.infoSection p {
  font-size: var(--cxy-fontSize-s);
  line-height: var(--cxy-lineHeight-m);
  font-weight: var(--cxy-fontWeight-medium);
  margin-top: var(--cxy-spacing-2);
}

.authSection {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: var(--cxy-spacing-4);
  width: 100%;
}
@media (min-width: 768px) {
  .authSection {
    padding: 5rem;
  }
}
.authSection h2 {
  font-size: 1.5rem;
  line-height: var(--cxy-lineHeight-xl);
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cxy-spacing-2);
  color: var(--content-default);
}
.authSection h2 svg {
  width: 1.5rem;
  height: 1.5rem;
  margin-bottom: var(--cxy-spacing-1);
  color: var(--cxy-color-brand);
}
.authSection h2 svg path {
  stroke: var(--cxy-color-brand);
}
.authSection .switchAuthText {
  font-size: var(--cxy-fontSize-m);
  line-height: var(--cxy-lineHeight-l);
  text-align: center;
  font-weight: var(--cxy-fontWeight-bold);
}
.authSection .switchAuthText a {
  color: var(--cxy-color-brand);
  text-decoration: underline;
}
